import { FC } from 'react';
import { DatePickerProps } from 'formik-antd';

import { dateRange } from '../../../assets';
import DatePickerStyled from './styles';

const DatePickerField: FC<DatePickerProps> = (props) => {
  return (
    <DatePickerStyled inputReadOnly={true} {...props} suffixIcon={<img src={dateRange} alt="" />} />
  );
};

export default DatePickerField;
